export enum CodeActionTypes {
    FETCH_LOGIN = '@@authorization/FETCH_LOGIN',
    SET_LOGIN = '@@authorization/SET_LOGIN',
    FETCH_ERROR = '@@authorization/FETCH_ERROR',
}

export interface loginStateInterface {
    readonly access_token: string,
    readonly loading: boolean
}
